import { render } from "./ReferralInformationForm.vue?vue&type=template&id=3f906575"
import script from "./ReferralInformationForm.ts?vue&type=script&lang=js&external"
export * from "./ReferralInformationForm.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__